/**
 * Game data the backend needs, taken from the ported game tables (single source of truth: src/game/data,
 * generated from FWP.init_data_arrays). Isolated here so that the rest of the backend does not depend on
 * the game module layout. The 14 fixed clans of the original (CLANS_DEF) are not among them: clans are made by
 * players (services/clans.ts).
 */
import { create_LEVEL_THRESHOLD } from '../../game/data/LEVEL_THRESHOLD';
import { create_WEAPONS_DEF } from '../../game/data/WEAPONS_DEF';

const LEVEL_THRESHOLD: readonly number[] = (create_LEVEL_THRESHOLD() as unknown[]).map((v) => Number(v));

/** FWP.get_player_level (FWP.as:18377-18386): largest level whose threshold is <= exp. */
export function levelFromExp(exp: number): number {
  let l = 1;
  while (l < LEVEL_THRESHOLD.length && LEVEL_THRESHOLD[l] <= exp) l++;
  return l - 1;
}

/**
 * Hourly tribute per assault zone = TEAMS_DEF["assault<z>"].payments (FWP.as:5618; table in
 * docs/analysis/meta-game.md §22).
 */
export const ASSAULT_ZONE_PAYMENTS: readonly number[] = [
  500, 800, 1000, 2000, 5000, 8000, 10000, 11000, 12000, 14000, 15000, 20000, 25000, 30000, 35000, 40000, 45000,
];

let weaponIdSet: ReadonlySet<number> | null = null;

/** Ids of every weapon of WEAPONS_DEF (a weapon choice in battle input must name one of them). */
export function weaponIds(): ReadonlySet<number> {
  if (!weaponIdSet) {
    const def = create_WEAPONS_DEF() as Record<string, { id: unknown }>;
    weaponIdSet = new Set(Object.values(def).map((w) => Number(w.id)).filter((id) => Number.isInteger(id)));
  }
  return weaponIdSet;
}
